import {inject, Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

export interface SurveyQuestionDto {
  id: number;
  title: string;
}

export interface SurveySubmissionRequest {
  suggestion?: string;
  question: Record<string, number>;
}

/**
 * The satisfaction survey lives in the portal (work item 185): its จัดการคำถามแบบสอบถาม decides
 * which questions are published for which site and in what order, and its reports read the
 * answers. So both calls go straight to the portal's public survey API as SUPPLY_CHAIN — the
 * same way e-Coding does — on a bare HttpClient so the app's interceptors (auth, loading, error
 * toasts) stay out of it; the page shows its own load/submit dialogs.
 */
@Injectable({providedIn: 'root'})
export class SurveyApiService {
  private readonly publicHttp = new HttpClient(inject(HttpBackend));
  private readonly portalApiUrl = environment.portalBaseUrl;

  getQuestions(): Observable<SurveyQuestionDto[]> {
    return this.publicHttp.get<SurveyQuestionDto[]>(
      `${this.portalApiUrl}/api/public/surveys/questions`,
      {params: {useSite: 'SUPPLY_CHAIN'}}
    );
  }

  submitSurvey(payload: SurveySubmissionRequest): Observable<{ id: number }> {
    return this.publicHttp.post<{ id: number }>(
      `${this.portalApiUrl}/api/public/surveys`,
      payload,
      {params: {useSite: 'SUPPLY_CHAIN'}}
    );
  }
}
